import * as React from "react";

import { AreaMap, type MapVenue } from "@/pages/areas/components/area-map";
import type { Area, AreaVenueItem } from "@/types/area";

export interface AreaPreviewProps {
  area: Area;
  /** Every area of the city, with shapes: this one is highlighted among them. */
  cityAreas: Area[];
  venues: AreaVenueItem[];
}

/** This area drawn among its part and its city's other areas, zoomed to it. */
export const AreaPreview = ({ area, cityAreas, venues }: AreaPreviewProps) => {
  // Stable references: the map refits whenever these change, which must not happen per keystroke.
  const areas = React.useMemo(
    () =>
      cityAreas.some((a) => a.id === area.id)
        ? cityAreas
        : [...cityAreas, area],
    [cityAreas, area],
  );
  const pins = React.useMemo<MapVenue[]>(
    () =>
      venues.map((v) => ({
        id: v.id,
        name: v.name,
        lat: v.geolocation.latitude,
        lng: v.geolocation.longitude,
        hasArea: true,
      })),
    [venues],
  );
  return (
    <AreaMap
      areas={areas}
      venues={pins}
      highlightId={area.id}
      fitTo={area.id}
      className="h-[360px]"
    />
  );
};
